import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { Layout } from "./components/Layout";
import { useAuthStore } from "./stores/authStore";
import { Home } from "./pages/Home";
import { CreateWishlist } from "./pages/CreateWishlist";
import { WishlistView } from "./pages/WishlistView";
import { WishlistAdmin } from "./pages/WishlistAdmin";
import { CancelReservation } from "./pages/CancelReservation";
import { Login } from "./pages/Login";
import { Register } from "./pages/Register";
import { Profile } from "./pages/Profile";
import { UserWishlists } from "./pages/UserWishlists";

export default function App() {
  const checkAuth = useAuthStore((s) => s.checkAuth);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/create" element={<CreateWishlist />} />
        <Route path="/wishlist/:slug" element={<WishlistView />} />
        <Route path="/admin/:adminToken" element={<WishlistAdmin />} />
        <Route path="/cancel-reservation/:token" element={<CancelReservation />} />
        <Route path="/auth/login" element={<Login />} />
        <Route path="/auth/register" element={<Register />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/profile/wishlists" element={<UserWishlists />} />
      </Route>
    </Routes>
  );
}
